import { Core } from "cytoscape";

export const getViewportCenter = (cyRef: Core): { x: number; y: number } => {
  if (!cyRef) return { x: 0, y: 0 };

  const extent = cyRef.extent();
  return {
    x: (extent.x1 + extent.x2) / 2,
    y: (extent.y1 + extent.y2) / 2,
  };
};
